/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Guidance_New_MemberInputs */



/**
* | output |
* | --- |
* | "New to VEKN? Ask the organizer at the desk to add you." |
*
* @param {Vekn_Guidance_New_MemberInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_guidance_new_member = /** @type {((inputs?: Vekn_Guidance_New_MemberInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Guidance_New_MemberInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau sur VEKN ? Demandez à l'organisateur au bureau des inscriptions de vous ajouter.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Nuevo en VEKN? Pide al organizador en el mostrador de inscripciones que te añada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Novo na VEKN? Peça ao organizador no balcão de inscrições para te adicionar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo a VEKN? Chiedi all'organizzatore al banco iscrizioni di aggiungerti.")
	return /** @type {LocalizedString} */ ("New to VEKN? Ask the organizer at the desk to add you.")
});